export const distributionTypesMap = {
  DISTRIBUTING: "recommender.detailsModal.distributionTypes.distributing",
  RETAINED: "recommender.detailsModal.distributionTypes.retained",
};

export const distributionFrequencyMap = {
  MONTHLY: "recommender.detailsModal.distributionFrequency.monthly",
  ANNUALLY: "recommender.detailsModal.distributionFrequency.annually",
  QUARTERLY: "recommender.detailsModal.distributionFrequency.quarterly",
  HALF_YEARLY: "recommender.detailsModal.distributionFrequency.halfYearly",
  DAILY: "recommender.detailsModal.distributionFrequency.daily",
};
